import {SpinnerWrapper, Spinner} from './LoadingSpinner.styles';

const LoadingSpinner = () => (
  <SpinnerWrapper>
    <Spinner data-testid="spinner" />
  </SpinnerWrapper>
);

export default LoadingSpinner;
